import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LIMITREVIEWSLENGTH } from "Constants/Limit";
import Button from "ComponentsUI/Button";
import ReviewContainerV3 from "./ReviewContainerV3";
import { useReviewsData } from "hooks/useReviewsParams";

const ReviewListContainerV3 = (props) => {
	const { text, reviewLocation, queryType, onlyReviewsStyle } = props;
	const { reviewsList, houseFullInfo, regionFullInfo } = useReviewsData(queryType, reviewLocation);
	let defaultUserName = text.anonymous_resident;

	const [reviewsShowLength, setReviewsShowLength] = useState(
		reviewsList.length > LIMITREVIEWSLENGTH ? LIMITREVIEWSLENGTH : reviewsList.length
	);

	useEffect(() => {
		if (reviewsList.length && !reviewsShowLength) {
			setReviewsShowLength(() =>
				reviewsList.length > LIMITREVIEWSLENGTH ? LIMITREVIEWSLENGTH : reviewsList.length
			);
		}
	}, [reviewsList, reviewsList?.[0]?.id]);

	if (reviewsList.length === 0) {
		return null;
	}

	if (reviewLocation === "house" && houseFullInfo) {
		defaultUserName = `${text.resident_house} ${houseFullInfo?.house_full}`;
	} else if (reviewLocation === "street") {
		defaultUserName = `${text.resident_street}`;
	} else if (reviewLocation === "about_operator" && regionFullInfo) {
		defaultUserName += ` ${regionFullInfo.declinations?.genitive}`;
	}

	const showMoreReviewsHandler = () => {
		setReviewsShowLength((length) => {
			if (length >= reviewsList.length) {
				return LIMITREVIEWSLENGTH;
			} else {
				return length + LIMITREVIEWSLENGTH;
			}
		});
	};

	return (
		Boolean(reviewsList.length) && (
			<>
				{reviewsList.map((item, index) => {
					return (
						<ReviewContainerV3
							key={item.id}
							review={item}
							type={"review"}
							reviewsShowLength={reviewsShowLength}
							position={index + 1}
							defaultUserName={defaultUserName}
							onlyReviewsStyle={onlyReviewsStyle}
						/>
					);
				})}
				{reviewsList.length > LIMITREVIEWSLENGTH && (
					<Button
						onClick={() => {
							showMoreReviewsHandler();
						}}
						fullWidth={true}
						color="purplishBlue"
						transparent={true}
					>
						{reviewsShowLength >= reviewsList.length ? text.COLLAPSE_EVERY : text.TARIFF_SHOW_MORE}
					</Button>
				)}
			</>
		)
	);
};

ReviewListContainerV3.propTypes = {
	reviewLocation: PropTypes.string.isRequired,
	queryType: PropTypes.string.isRequired,
	text: PropTypes.object.isRequired,
	onlyReviewsStyle: PropTypes.bool,
};

ReviewListContainerV3.defaultProps = {
	onlyReviewsStyle: false,
};

export default ReviewListContainerV3;
